import { useQuery } from '@tanstack/react-query';
import { AwardsService } from '../services';
import { awardsKeys } from '../queryKeys';

// Reads GET /admin/cycles/:cycleId (awards-service 1.3.0). A null result means
// "not found" (the service maps a 404 to null); anything else that goes wrong
// surfaces via isError, so callers must distinguish the two.
export const useCycle = (cycleId) => {
  const { data, error, isError, isPending } = useQuery({
    queryKey: awardsKeys.cycle(cycleId),
    queryFn: () => AwardsService.getCycleById(cycleId),
    enabled: Boolean(cycleId),
    retry: false,
  });

  return { cycle: data ?? null, isPending, isError, error };
};
